import { render, staticRenderFns } from "./footMenu.vue?vue&type=template&id=af3c28fa&scoped=true"
import script from "./footMenu.vue?vue&type=script&lang=js"
export * from "./footMenu.vue?vue&type=script&lang=js"
import style0 from "./footMenu.vue?vue&type=style&index=0&id=af3c28fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3c28fa",
  null
  
)

export default component.exports